document.addEventListener('DOMContentLoaded', ()=>{
  if ( document.querySelectorAll('.shopify-section--product-template').length > 0 ){
    function isInViewportStickyElement(elem) {
        var bounding = elem.getBoundingClientRect();
        var myElementHeight = elem.offsetHeight;
        var myElementWidth = elem.offsetWidth;        
        return (bounding.top >= -myElementHeight 
                  && bounding.left >= -myElementWidth
                  && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
                  && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ;
      };
    
      var recommendationElement = document.querySelectorAll('.purchase-details');
      var recommendationElementFooter = document.querySelectorAll('.shopify-section--footer');
       window.addEventListener("scroll", function (event) {
         if( window.screen.width < 799 ){
             let scroll_y = this.scrollY;
             let TargetElementWp = document.querySelector('.purchase-details').offsetTop;
            // if( scroll_y > TargetElementWp ){
                 recommendationElement.forEach( (evt)=>{
                    if ( (isInViewportStickyElement(evt)) ) {
                        document.body.classList.remove('stickyAddToCart');
                    } else {
                        document.body.classList.add('stickyAddToCart');
                    }
                 }) 
                 recommendationElementFooter.forEach( (evt)=>{
                    if ( (isInViewportStickyElement(evt)) ) {
                        document.body.classList.remove('stickyAddToCart');
                    }
                 })
            // }else{
            //      recommendationElement.forEach( (evt)=>{
            //       document.body.classList.remove('stickyAddToCart');
            //      })           
            // }
         }
       }) 

         if( window.screen.width < 799 ){
                 recommendationElement.forEach( (evt)=>{
                    if ( (isInViewportStickyElement(evt)) ) {
                        document.body.classList.remove('stickyAddToCart');
                    } else {
                        document.body.classList.add('stickyAddToCart');
                    }
                 }) 
                 recommendationElementFooter.forEach( (evt)=>{
                    if ( (isInViewportStickyElement(evt)) ) {
                        document.body.classList.remove('stickyAddToCart');
                    }
                 })
         }
  }

  document.querySelector('.ScrollerPdpAtc').addEventListener('click', (event)=>{
    event.preventDefault();
    document.querySelector('.VariantPopupBox_Appeared').classList.add('active');
    document.body.classList.add('HoverdMe');
  });

  document.querySelector('.CrossSkpopup').addEventListener('click', (event)=>{
    event.preventDefault();
    document.querySelector('.VariantPopupBox_Appeared').classList.remove('active'); document.body.classList.remove('HoverdMe');
  });

  document.querySelectorAll('.product-info__size-button').forEach((evt)=>{
    evt.addEventListener('change', (target)=>{
      target.preventDefault();
      let VarintIdStk = Array.from(document.querySelectorAll('[name="size_id"]')).find( (radio) => radio.checked)?.value;
      let formDataInit = {
       'items': [{
        'id': VarintIdStk,
        'quantity': 1
        }]
      };      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formDataInit)
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        $.ajax({
            type: 'GET',
            url: '/',
            dataType: 'html',
            success: function(html_get) {
              setTimeout(function() {  
                $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
                $('#CartDrawer-Form').html($(html_get).find('#CartDrawer-Form').html());
                $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
                $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
              },1200)
            }
          });
      })  
      .catch((error) => {
        console.error('Error:', error);
      }).finally( (ouput)=>{ 
        document.querySelector('.VariantPopupBox_Appeared').classList.remove('active');
        document.body.classList.remove('HoverdMe');
        document.querySelectorAll('[name="size_id"]').forEach((input)=>{
          input.checked = false;
        })
      })
    });
  });
  
});

$(function() {
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    $('body').addClass('safariMacDazi');
  }
});

$(document).ready(function() {
   if (window.location.href.indexOf("?viewcart=true") > -1) {
     $("div#main-cart-items1").addClass("cart_cv_active");
     $("body").addClass("cart_cv_body");
     window.history.pushState({}, '', ".");  
 }
});

//cart drawer remove and add
$(document).on("click",".cart_id_drawer",function (e) {
  e.preventDefault();

        $(".drawers").toggle();
      });

      $(document).on("click",".remove_btn",function (e) {
        e.preventDefault();
        $('.drawers').hide();
    });


// on click body cart drawer close

$(document).mouseup(function (e) {
    var drawers = $('.drawers');
    var cartContents = $('.cart__contents');

    if (!drawers.is(e.target) && drawers.has(e.target).length === 0 &&
        !cartContents.is(e.target) && cartContents.has(e.target).length === 0) {
        console.log('Clicked outside .drawers and .cart__contents');
        drawers.removeClass('cart_cv_active');
        $('body').removeClass('cart_cv_body');
    }
});

//cross cart drawer close and class remove

       $(document).on("click",".remove_btn",function (e) {
         e.preventDefault();
        $('.rebuy-modal-visible').removeClass();
    });

//add class on body and cart drawer

   $(document).on("click",".cart_id_drawer",function (e) {
     e.preventDefault();
     $('.drawers').addClass('cart_cv_active');
     $('body').addClass('cart_cv_body');
    });
 
  $(document).on("click",".remove_btn",function (e) {
     e.preventDefault();
        $('body').addClass('index feature_image promo-banner--true smart-cart--enabled');
      });

//remove class on body and cart drawer

   $(document).on("click",".remove_btn",function (e) {
     e.preventDefault();
        $('.drawers').removeClass('cart_cv_active');
     $('body').removeClass('cart_cv_body');
    });

//on click bin cart drawer items remove

  $(document).on("click","#remove_text_bin1",function (e) {
    e.preventDefault();
    var Obj =  $(this).attr("data_line");
  
    //alert(Obj);
    let updates = {
     [Obj]: 0
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      return response.json();
    }).then( results => {
       $.ajax({
         type: 'GET',
         url: '/',
         dataType: 'html',
         success: function(html_get) {
           $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
           $('#CartDrawer-Form').html($(html_get).find('#CartDrawer-Form').html());
     
          
           $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
           $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
         
          //  console.log(html_get);
         },
       });
    })
    .catch((error) => {
    //  console.error('Error:', error);
    });
  });


//on click qty add price update
    $(document).on("click","button.qty-count.qty-count--add",function (e) {
       e.preventDefault();
       var input_value = $(this).parents(".qty-input").find(".product-qty").val();
        var final_val = parseInt(input_value) + 1;
       $(this).parents(".qty-input").find(".product-qty").val(final_val);
      var line_items=$(this).parents('.qty-input').attr('data_line');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:   {
        quantity: final_val,
        id: line_items
      },
        dataType: 'json',
        success: function(json_data) {
          $.ajax({
           type: 'GET',
         url: '/',
        dataType: 'html',
        success: function(html_get) {
            $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
            $('#CartDrawer-Form').html($(html_get).find('#CartDrawer-Form').html());
            $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
            $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
        },
              });
      },
      });
    });

//on click minus cart drawer item less

    $(document).on("click","button.qty-count.qty-count--minus",function (e) {
       e.preventDefault();
       var input_value = $(this).parents(".qty-input").find(".product-qty").val();
      if( input_value > 0){
        var final_val =input_value - 1;
       $(this).parents(".qty-input").find(".product-qty").val(final_val);
              var line_items=$(this).parents('.qty-input').attr('data_line');
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data:   {
        quantity: final_val,
        id: line_items
      },
        dataType: 'json',
        success: function(json_data) {
          $.ajax({
           type: 'GET',
         url: '/',
        dataType: 'html',
        success: function(html_get) {

setTimeout(function() {  
            $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
            $('#CartDrawer-Form').html($(html_get).find('#CartDrawer-Form').html());
            $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
            $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
       
 },1200) },
              });
      },
      });
      }
    });

// on click pdp page atc item add on cart drawer
// $('.add_to_cart').on('click', function(e) {
//   e.preventDefault();
//     var FormSerialize = $(this).parents('form').serialize();
//     $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: FormSerialize,
//     dataType: 'json',
//     success: function(json_data) {
//       $.ajax({
//           type: 'GET',
//           url: '/',
//           dataType: 'html',
//           success: function(html_get) {

// setTimeout(function() {  
//             $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
//             $('#CartDrawer-Form').html($(html_get).find('#CartDrawer-Form').html());
//             $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
//             $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
  


//           },1200)
// }
//         });
//     }
//   });
// });



//on best selling

$('.add-to-cart-button').on('click', function(e) {
  e.preventDefault();
    var pric = $(this).parents('form').children('[name="id"]').val();
      $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).parents('form').serialize(),
    dataType: 'json',
    success: function(html_get) {

              $.ajax({
           type: 'GET',
           url: '/',
           dataType: 'html',
           success: function(html_get) {
            $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
                $('.cart_icon_cv').html($(html_get).find('.cart_icon_cv').html());
            $('body').addClass('cart_cv_body');$(".drawers").addClass('cart_cv_active');
           },
           });
    },
    error: function() {
      // Do something on error (e.g. show an error message)
    }
  });
});



//upsell product


 $(document).on("click","button.cv_upsell_button",function (e) {
   e.preventDefault();
    $(this).hide();
    $(this).parents('.cv_upsell_product').children('.optiion_cv_variant').show();
    $(this).parents('.cv_upsell_product').children('.cv_upsell_prouct_actions').children('.cv_upsell_addbutton').show();
});
  $(document).on("change",".CartUpsellVariantSelection select",function () {
    var get_op_val = $(this).val();
    $(this).parents(".cv_upsell_product").find("button.cv_upsell_addbutton").attr("data-id",get_op_val);
});


  $(document).on("change",".optiion_cv_variant select",function () {
    var get_op_val = $(this).val();
    $(this).parents(".product-thumbnail__info-container").children('form').children('[name="id"]').val(get_op_val);
});

    $(document).on("click","button.cv_upsell_addbutton",function () {
     var line_items=$(this).attr('data-id');
      var currenthtml = $(this).html();
      $(this).html('Adding...');
      var thisitem = $(this)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:   {
        quantity: 1,
        id: line_items
      },
        dataType: 'json',
        success: function(json_data) {
          $.ajax({
           type: 'GET',
         url: '/',
        dataType: 'html',
        success: function(html_get) {
          $(thisitem).html("Added!");
        setTimeout(function() {
           $('div#main-cart-items1').html($(html_get).find('div#main-cart-items1').html());
          
 function updateCartCount() {
      $.getJSON('/cart.js', function(cart) {
        var itemCount = cart.item_count || 0;
         $('li.cart_id_drawer.cart span.cart_icon_cv.icon-cart.cart-button span').text(itemCount);
      });
    }
    updateCartCount();
    // $('li.cart_id_drawer.cart span.cart_icon_cv.icon-cart.cart-button span').html(item_count);
        },1200)
           
        },
              });
      },
      });
    });

$(document).ready(function () {
  $('.new-menu').click(function () {
    var widhtmob = $(window).width();
    if(widhtmob < 799){  
      $('.newmobilemenu').addClass('openmenu');
      $('body').addClass('openmenu');
      $('.new-menu').attr('aria-expanded', 'true');
    }
  });

  /* The menu opener is a link with no address, so a keyboard could not reach
     it or press it and a screen reader had nothing useful to announce. It is
     now marked up as a button in header.liquid; this listens for Enter and
     Space so it behaves the way a button is expected to. */
  $('.new-menu').on('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      $(this).trigger('click');
    }
  });
  $('.mainlists-menu').click(function () {
    if($(this).hasClass('openinnermenu')){
      $('.mainlists-menu').removeClass('openinnermenu');
       $('.innernewmenu').removeClass("openinnermenu");
    }else{
       $('.mainlists-menu').removeClass('openinnermenu');
       $('.innernewmenu').removeClass("openinnermenu");
      $(this).siblings('.innernewmenu').addClass("openinnermenu");
    $(this).addClass('openinnermenu');
    } 
  });
  $('.innernewmenuheader').click(function () {
    $(this).parent('.innernewmenu').removeClass("openinnermenu");
  });
  $('.closenewmenu').click(function () {
     $('.newmobilemenu').removeClass('openmenu');
    $('body').removeClass('openmenu');
    /* Tell screen readers the menu is shut again, and put the keyboard back
       on the menu button so the shopper does not lose their place. */
    $('.new-menu').attr('aria-expanded', 'false').focus();
  });
});

